__turbopack_context__.v({
  "actions": "download-list-item-module-scss-module__vid26G__actions",
  "chevron": "download-list-item-module-scss-module__vid26G__chevron",
  "chevronOpen": "download-list-item-module-scss-module__vid26G__chevronOpen",
  "content": "download-list-item-module-scss-module__vid26G__content",
  "description": "download-list-item-module-scss-module__vid26G__description",
  "dropdown": "download-list-item-module-scss-module__vid26G__dropdown",
  "dropdownItem": "download-list-item-module-scss-module__vid26G__dropdownItem",
  "dropdownItemSize": "download-list-item-module-scss-module__vid26G__dropdownItemSize",
  "dropdownMenu": "download-list-item-module-scss-module__vid26G__dropdownMenu",
  "dropdownTrigger": "download-list-item-module-scss-module__vid26G__dropdownTrigger",
  "item": "download-list-item-module-scss-module__vid26G__item",
  "title": "download-list-item-module-scss-module__vid26G__title",
});
